import CryptoJS from "crypto-js";
import Vue from 'vue'


export const isNotNullORBlank = (...args) => {
    const reg = /^\s+$/;
    for (var i = 0; i < args.length; i++) {
        var argument = args[i];
        if (argument == null || argument == undefined || reg.test(reg)) return false;
    }
    return true;
}

let key_value = 'Jack66Luo1likai8';
export const encrypt = (value) => {
    if (!value) {
        return null;
    }
    return CryptoJS.AES.encrypt(value, CryptoJS.enc.Utf8.parse(key_value), {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    }).toString();
}

export const decrypt = (value) => {
    if (!value) {
        return null;
    }
    return CryptoJS.enc.Utf8.stringify(
        CryptoJS.AES.decrypt(value, CryptoJS.enc.Utf8.parse(key_value), {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        })
    ).toString();
}

//get address field
export const getQueryStr = (str) => {
    var local = String(window.document.location.href);
    var rs = new RegExp('(^|)' + str + '=([^&]*)(&|$)', 'gi').exec(local),
        tmp;
    if ((tmp = rs)) {
        return tmp[2];
    }
    return '';
}

//获取地址栏参数//可以是中文参数
export const getUrlParam = (key) => {
    // 获取参数
    var url = window.location.search;
    // 正则筛选地址栏
    var reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)');
    // 匹配目标参数
    var result = url.substr(1).match(reg);
    //返回参数值
    return result ? decodeURIComponent(result[2]) : null;
}

//设置cookie
export const setCookie = (cname, cvalue, exdays) => {
    var d = new Date();
    var cookieStr = cname + "=" + cvalue;
    if (exdays) {
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toGMTString();
        cookieStr = cookieStr + "; " + expires;
    }
    document.cookie = cookieStr;
}

//获取cookie
export const getCookie = (cname) => {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i].trim();
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return "";
}

//清除cookie
export const clearCookie = (cname) => {
    var cval = getCookie(cname);
    if (cval != null) {
        setCookie(cname, "", -1);
    }
};

export function cusError(message, name) {
    const error = new Error(message);
    if (name)
        error.name = name;
    else
        error.name = "cusError";
    return error;
}

export function checkCookieExpire(cookies) {
    if(cookies.get("Id")) {
        return true;
    } else {
        return false;
    }
}

//检查session

// export function checkSession(user) {
//     return new Promise((resolve, reject) => {
//       postRequest("checkSession", {
//         loginid: cookies.get("id"),
//         clienthost: sessionStorage.getItem('ip'),
//       })
//         .then(res => {
//           let datas = res.data;
//           if(!datas.success){
//             logout(user);
//           }
//         })
//         .catch(error => {
//           reject(error);
//         });
//     });
//   }

//   export function logout(user) {
//     logoutHandle(user)
//       .then(res => {
//         if (res.success) {
//           _this.$router.go(0);
//           _this.$store.commit("user/removeUser");
//           _this.$router.replace("/login?langcode=" + _this.$i18n.locale);
          
//         } else {
//           _this.$message.error(res.message);
//         }
//       })
//       .catch(error => {
//         _this.$message.error(_this.$t("warning_pageText.CONNECTFAIL"));
//       });
//   }

//   export function logoutHandle(user) {
//     return new Promise((resolve, reject) => {
//       postRequest("userLogout", {
//         loginid: user.loginid,
//         logintype: user.logintype,
//         token: token
//       })
//         .then(res => {
//           resolve(res.data);
//         })
//         .catch(error => {
//           reject(error);
//         });
//     });
//   }

export const preventReClick = Vue.directive('preventReClick', {
    inserted: function (el, binding) {
        el.addEventListener('click', () => {
            if (!el.disabled) {
                el.disabled = true
                setTimeout(() => {
                    el.disabled = false
                }, binding.value || 3000)
            }
        })
    }
});